import styled, { css } from "styled-components";

interface ModalHeaderProps {}

export const StyledMemberFooterBar = styled.div<ModalHeaderProps>`
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 27px;
  background: #303030;
  margin-top: 22.5px;
`;

StyledMemberFooterBar.defaultProps = {};
